<template lang="pug">
    div.step_bar_container
        div.item_left
            span.item_label
                i(class="iconfont icon-buzhoutiao1" v-show="step == 2")
                span(v-show="step == 1") 1 
            span 获取密码
        span.line(v-show="step == 2")
        div.item_right
            span.item_label(:class="[step == 1? 'disabled' : '']") {{ 2 }}
            span(:class="[step == 1? 'grey' : '']") 完善信息
</template>

<script type="text/javascript">
    export default {
        data () {
            return {
                arrStep: [1, 2]
            }
        },
        props: {
            step: {
                type: Number,
                default: 1
            }
        }
    }
</script>

<style lang="sass" scoped>
.step_bar_container
    position: relative
    width: 360px
    @include clearfix()
    &::before
        position: absolute
        top: 9px
        display: block
        content: ''
        width: 100%
        height: 2px
        background: linear-gradient(270deg,rgba(255,255,255,1) 0%,rgba(233,233,233,1) 23%,rgba(233,233,233,1) 79%,rgba(255,255,255,1) 100%)
.item_label
    position: absolute
    left: 50%
    top: 0
    display: inline-block
    width: 20px
    height: 20px
    margin-left: -10px
    text-align: center
    color: #fff
    font-size: 12px
    line-height: 20px
    border-radius: 10px
    background-color: $main-color
    &.disabled
        background-color: #E9E9E9
.item_left, .item_right
    position: relative
    margin: 0 44px
    padding-top: 28px
    font-weight: 400
    font-size: 16px
.item_left
    float: left
.item_right
    float: right
.line
    position: absolute
    top: 9px
    left: 50%
    display: block
    width: 188px
    height: 2px
    margin-left: -94px 
    background-color: $main-color
.icon-buzhoutiao1
    font-size: 12px
.grey
    color: #999
</style>